// extracted by mini-css-extract-plugin
export default {"footer-banner":"footer_footer-banner__Go3wR","img-section":"footer_img-section__yhr3e"};